<template>
  <v-form @submit.prevent ref="form" v-model="valid">
    {{ valid }}
    <mapping-form :doc="doc" :categories="categories" :zones="zones" />
    <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
    <pre>
        {{ doc }}
      </pre
    >
  </v-form>
</template>

<script>
// @ is an alias to /src
import MappingForm from "./MappingForm";
import { mapState } from "vuex";

export default {
  name: "UserMappingAdd",
  components: {
    MappingForm,
  },
  props: {
    doc: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    zones: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("saveNote", this.doc);
    },
    populateField(field) {
      return field ? field : null;
    },
    validate() {
      this.$refs.form.validate();
    },
  },
};
</script>
